export default __webpack_public_path__ + "static/media/covid_19.7cf59524.jpg";